import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fabrics } from '../config';

var getColourFabricImage = function getColourFabricImage(colour, fabric) {
  return {
    src: encodeURI("https://media.4rgos.it/i/Argos/MTO-".concat(colour, "-").concat(fabric)),
    alt: "".concat(colour, " ").concat(fabric),
    height: 80,
    width: 80,
    cropParams: {
      xCoord: 0,
      yCoord: 0,
      cropWidth: 800,
      cropHeight: 800
    }
  };
};

var getLegFinishImage = function getLegFinishImage(feetColour, partNumber) {
  return {
    src: encodeURI("https://media.4rgos.it/i/Argos/".concat(partNumber, "_R_Z004A")),
    alt: "".concat(feetColour, " feet colour"),
    width: 225
  };
};

var groupByTypeValue = function groupByTypeValue(data, type, key) {
  return data.reduce(function (storage, item) {
    var group = item.attributes.find(function (attr) {
      return attr.type === type;
    }) && item.attributes.find(function (attr) {
      return attr.type === type;
    })[key]; // defensive code because sometimes attr are missing

    if (group) {
      storage[group] = storage[group] || []; // eslint-disable-line no-param-reassign

      storage[group].push(item);
    }

    return storage;
  }, {});
}; // Get all variants with same attributes except for one unique attribute
// Example: Get all variants of a SKU with the same color except for service type (the unique attribute)


var getSimilarVariants = function getSimilarVariants(allVariants, uniqueAttribute, partNumber) {
  var selectedVariant = allVariants === null || allVariants === void 0 ? void 0 : allVariants.find(function (variant) {
    return variant.partNumber === partNumber;
  });

  var _ref = selectedVariant || {},
      _ref$attributes = _ref.attributes,
      selectedVariantAttributes = _ref$attributes === void 0 ? [] : _ref$attributes;

  var uniqueVariantType = selectedVariantAttributes === null || selectedVariantAttributes === void 0 ? void 0 : selectedVariantAttributes.find(function (attribute) {
    return attribute.type === uniqueAttribute;
  });

  if (uniqueVariantType) {
    // Get all attributes of the selected variant excluding the unique attribute
    var nonUniqueAttributes = selectedVariantAttributes === null || selectedVariantAttributes === void 0 ? void 0 : selectedVariantAttributes.filter(function (attribute) {
      return attribute !== uniqueVariantType;
    });
    var similarVariants = allVariants.filter(function (variant) {
      var attributes = variant.attributes; // For each variant, check that all attributes match the attributes of the selected variant EXCEPT for the unique attribute

      var hasSimilarVariants = attributes.filter(function (attribute) {
        return attribute.type !== uniqueAttribute;
      }).every(function (attribute) {
        return nonUniqueAttributes.some(function (otherAttribute) {
          return otherAttribute.type === attribute.type && otherAttribute.value === attribute.value;
        });
      });
      return hasSimilarVariants;
    }).map(function (variant) {
      return variant.partNumber;
    });
    return similarVariants;
  }

  return [];
}; // Sorts the variants by the order array


var sortByOrderArray = function sortByOrderArray(obj) {
  var orderArray = fabrics.map(function (fabric) {
    return fabric.heading;
  }); // Get all keys in the object that are in the order array

  var includedKeys = Object.keys(obj);
  var sortKeys = includedKeys.sort(function (firstElement, secondElement) {
    // Get the index of the keys in the order array
    var indexA = orderArray.indexOf(firstElement);
    var indexB = orderArray.indexOf(secondElement); // If both keys are in the order array, sort by index

    if (indexA > -1 && indexB > -1) {
      return indexA - indexB;
    } // If indexA is in orderArray and indexB is not, indexA should come first


    if (indexA !== -1) return -1; // If indexB is in orderArray and indexA is not, indexB should come first

    if (indexB !== -1) return 1; // If neither key is in orderArray, maintain the order

    return 0;
  });
  var sortedObj = {}; // Loop through the sortKeys array and add the data from obj to sortedObj

  sortKeys.forEach(function (key) {
    sortedObj[key] = obj[key];
  });
  return sortedObj;
}; // Find the current variant based on the part number


var findCurrentVariant = function findCurrentVariant(variants, currentPartNumber) {
  return variants.find(function (variant) {
    return variant.partNumber === currentPartNumber;
  });
};

var fetchProductData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(productId) {
    var URL, OPTIONS, response, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!productId) {
              _context.next = 10;
              break;
            }

            URL = "/product-api/pdp-service/partNumber/".concat(productId);
            OPTIONS = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            };
            _context.next = 5;
            return fetch(URL, OPTIONS);

          case 5:
            response = _context.sent;
            _context.next = 8;
            return response.json();

          case 8:
            data = _context.sent;
            return _context.abrupt("return", data);

          case 10:
            return _context.abrupt("return", Promise.reject(new Error('No productId provided')));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchProductData(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var findVariantsFromProduct = function findVariantsFromProduct(productData) {
  var _productData$included, _productData$included2;

  return productData === null || productData === void 0 ? void 0 : (_productData$included = productData.included.find(function (_ref3) {
    var type = _ref3.type;
    return type === 'variants';
  })) === null || _productData$included === void 0 ? void 0 : (_productData$included2 = _productData$included.attributes) === null || _productData$included2 === void 0 ? void 0 : _productData$included2.variants;
};

var getProductAttributes = function getProductAttributes(product) {
  var _product$attributes;

  if (!product) return {};
  var attributes = product === null || product === void 0 ? void 0 : (_product$attributes = product.attributes) === null || _product$attributes === void 0 ? void 0 : _product$attributes.reduce(function (obj, attr) {
    var newAttributes = _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, attr.type, attr.value));

    return newAttributes;
  }, {});
  return attributes;
};

var sortByFeetColourAsc = function sortByFeetColourAsc(productVariants) {
  if (!productVariants) return []; // Filter out variants without a feet colour attribute

  var variants = productVariants.filter(function (variant) {
    var _getProductAttributes;

    return (_getProductAttributes = getProductAttributes(variant)) === null || _getProductAttributes === void 0 ? void 0 : _getProductAttributes['Feet colour'];
  });
  return variants.sort(function (a, b) {
    var _getProductAttributes2, _getProductAttributes3, _getProductAttributes4, _getProductAttributes5;

    var feetColourA = (_getProductAttributes2 = getProductAttributes(a)) === null || _getProductAttributes2 === void 0 ? void 0 : (_getProductAttributes3 = _getProductAttributes2['Feet colour']) === null || _getProductAttributes3 === void 0 ? void 0 : _getProductAttributes3.toLowerCase();
    var feetColourB = (_getProductAttributes4 = getProductAttributes(b)) === null || _getProductAttributes4 === void 0 ? void 0 : (_getProductAttributes5 = _getProductAttributes4['Feet colour']) === null || _getProductAttributes5 === void 0 ? void 0 : _getProductAttributes5.toLowerCase();
    return feetColourA === null || feetColourA === void 0 ? void 0 : feetColourA.localeCompare(feetColourB);
  });
};

var getDisplayPriceByFabric = function getDisplayPriceByFabric(variants) {
  return variants === null || variants === void 0 ? void 0 : variants.reduce(function (acc, variant) {
    var updatedAcc = {
      price: acc.price,
      isIdentical: acc.isIdentical
    };

    if (variant.price !== acc.price) {
      updatedAcc.isIdentical = false;
    }

    if (variant.price < acc.price) {
      updatedAcc.price = variant.price;
    }

    return updatedAcc;
  }, {
    price: variants === null || variants === void 0 ? void 0 : variants[0].price,
    isIdentical: true
  });
};

export { getColourFabricImage, findCurrentVariant, getLegFinishImage, groupByTypeValue, getSimilarVariants, sortByOrderArray, fetchProductData, findVariantsFromProduct, getProductAttributes, sortByFeetColourAsc, getDisplayPriceByFabric };